<!-- Legacy wrapper - now uses modern date-time picker internally -->
<app-modern-date-time-picker
  [label]="label"
  [startingValue]="startingValue"
  [minDate]="minDate"
  [maxDate]="maxDate"
  [newValueTriggered$]="newValueTriggered$"
  (dateOnSelection)="dateOnSelection.emit($event)"
></app-modern-date-time-picker>
